import React from 'react';
import { CartesianChart } from './CartesianChart';
import { PieChart } from './PieChart';
import { TreeMap } from './TreeMap';

// Define chart components using the new structure
const CHART_TYPES = {
  'pie': PieChart,
  'tree-map': TreeMap,
  'line': CartesianChart,
  'vertical-bar': CartesianChart,
  'horizontal-bar': CartesianChart,
  'stacked-bar': CartesianChart,
  'horizontal-stacked-bar': CartesianChart,
  'multi-bar-line': CartesianChart,
};

// Factory function to create the appropriate chart component based on type
export const ChartFactory = ({ type, data, config, isDrilledDown }) => {
  if (!data) {
    return null;
  }

  const isValidData = Array.isArray(data) 
    ? data.length > 0 
    : Object.values(data).every(d => Array.isArray(d) && d.length > 0);

  if (!isValidData) {
    return null;
  }

  const primaryChartType = config.defaultChartType || 'vertical-bar';
  const ChartComponent = CHART_TYPES[type] || CHART_TYPES[primaryChartType];

  if (!ChartComponent) {
    console.warn(`Unknown or unsupported chart type: ${type || primaryChartType}`);
    return null;
  }

  return <ChartComponent
    data={data}
    config={config}
  />;
}; 
